import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';

export const useWayBillList = (orderId: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useGuoJiamethodcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useGuoJia-${orderId}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useGuoJia-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useGuoJia-error-${orderId}`);

  // 发起支付
  const wayBillList = async (customQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.wayBillList(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0 && res.data) {
        result.value = res.data;
      } else {
        result.value = null;
        error.value = res.message || null;
      }
    } catch (err) {
      result.value = null;
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return {
    wayBillList,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
